import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Meta               from 'app/components/common/meta';
import CadminLayout       from 'app/components/company-admin/layout/';
import Builder            from 'app/components/company-admin/campaigns/builder';
import PageLoading        from 'app/components/layout/page-loading';
import CadminSlx          from 'app/selectors/company-admin/';
import CampaignProfile    from 'app/components/campaigns/campaign-profile';
import PageSlx            from 'app/selectors/company-admin/page-campaigns-new';


class PageCadminNewCampaign extends React.PureComponent {

  render() {
    const { company, campaign } = this.props;
    if (!company) return <PageLoading />;

    const builder = <Builder />;

    return (
      <CadminLayout className="page-cadmin-campaign-builder new" company={company} activeItem="campaigns" builder={builder}>
        <Meta title="New Campaign | Millie" />
        <CampaignProfile campaign={campaign} company={company} editMode />
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  campaign: PageSlx.campaign(state),
});

const dispatchToProps = (dispatch) => ({
});

export default connect(stateToProps, dispatchToProps)(PageCadminNewCampaign);
